export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 1187
// module chunks = 0